import { jsx as _jsx } from "react/jsx-runtime";
import { MediumFormatting } from "@faire/web--source/common/localization/formatting";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import { useFirstOrderIncentiveFormattedData } from "@faire/retailer/hooks/firstOrderIncentive/useFirstOrderIncentiveFormattedData";
import { useFirstOrderIncentiveStore } from "@faire/retailer-visitor-shared/hooks/firstOrderIncentive/useFirstOrderIncentiveStore";
import { useFirstOrderIncentiveTimeRemaining } from "@faire/retailer/hooks/firstOrderIncentive/useFirstOrderIncentiveTimeRemaining";
import { useVerticalizedFOITopBannerText } from "./useVerticalizedFOITopBannerText";
export var useGenericText = function() {
    var _useFirstOrderIncentiveStore = useFirstOrderIncentiveStore(), formattedIncentiveData = _useFirstOrderIncentiveStore.formattedIncentiveData, isMaximalistFoi = _useFirstOrderIncentiveStore.isMaximalistFoi, isFirstOrderForFaireDirectIncentive = _useFirstOrderIncentiveStore.isFirstOrderForFaireDirectIncentive;
    var verticalizedText = useVerticalizedFOITopBannerText();
    var expiresAt = formattedIncentiveData.expiresAt;
    var hoursRemaining = useFirstOrderIncentiveTimeRemaining(expiresAt !== null && expiresAt !== void 0 ? expiresAt : 0).hoursRemaining;
    var formattedIncentivePercent = useFirstOrderIncentiveFormattedData().formattedIncentivePercent;
    var genericLessThan24HoursText = function() {
        if (isFirstOrderForFaireDirectIncentive) {
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "IL4+FN",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Last day!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Enjoy "
                    },
                    {
                        type: 1,
                        value: "percentNumber"
                    },
                    {
                        type: 0,
                        value: " off with any brand."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    percentNumber: formattedIncentivePercent
                }
            });
        }
        if (isMaximalistFoi) {
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "wOHEk3",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Last day!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Enjoy "
                    },
                    {
                        type: 1,
                        value: "percentNumber"
                    },
                    {
                        type: 0,
                        value: " off and free shipping."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    percentNumber: formattedIncentivePercent
                }
            });
        }
        return /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "Hg7uD1",
            defaultMessage: [
                {
                    type: 8,
                    value: "MediumFormatting",
                    children: [
                        {
                            type: 0,
                            value: "Last day!"
                        }
                    ]
                },
                {
                    type: 0,
                    value: " Enjoy "
                },
                {
                    type: 1,
                    value: "percentNumber"
                },
                {
                    type: 0,
                    value: " off."
                }
            ],
            values: {
                MediumFormatting: MediumFormatting,
                percentNumber: formattedIncentivePercent
            }
        });
    };
    var genericLessThan48HoursText = function() {
        if (isFirstOrderForFaireDirectIncentive) {
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "9whNvl",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "2 days left!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Enjoy "
                    },
                    {
                        type: 1,
                        value: "percentNumber"
                    },
                    {
                        type: 0,
                        value: " off with any brand."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    percentNumber: formattedIncentivePercent
                }
            });
        }
        if (isMaximalistFoi) {
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "GgJ0Pe",
                defaultMessage: [
                    {
                        type: 8,
                        value: "MediumFormatting",
                        children: [
                            {
                                type: 0,
                                value: "2 days left!"
                            }
                        ]
                    },
                    {
                        type: 0,
                        value: " Enjoy "
                    },
                    {
                        type: 1,
                        value: "percentNumber"
                    },
                    {
                        type: 0,
                        value: " off and free shipping."
                    }
                ],
                values: {
                    MediumFormatting: MediumFormatting,
                    percentNumber: formattedIncentivePercent
                }
            });
        }
        return /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "MOdTWF",
            defaultMessage: [
                {
                    type: 8,
                    value: "MediumFormatting",
                    children: [
                        {
                            type: 0,
                            value: "2 days left!"
                        }
                    ]
                },
                {
                    type: 0,
                    value: " Enjoy "
                },
                {
                    type: 1,
                    value: "percentNumber"
                },
                {
                    type: 0,
                    value: " off."
                }
            ],
            values: {
                MediumFormatting: MediumFormatting,
                percentNumber: formattedIncentivePercent
            }
        });
    };
    var genericText = function() {
        switch(true){
            case hoursRemaining < 24:
                return genericLessThan24HoursText();
            case hoursRemaining < 48:
                return genericLessThan48HoursText();
            default:
                return verticalizedText;
        }
    };
    return genericText();
};
